import { FaFeather, FaTimes } from "react-icons/fa";
import { IFeature } from "../api/services/feature.service";
import FeatureDialogListSection from "./FeatureDialogListSection";
import GenericDialog from "./shared/GenericDialog";

export default function FeatureDialog({
  isOpen,
  setIsOpen,
  features,
  userId,
}: {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  features: IFeature[];
  userId: string;
}) {
  return (
    <>
      <GenericDialog
        onUpperRightClick={() => setIsOpen(false)}
        upperRightIcon={
          <FaTimes size={20} className="text-gray-600 dark:text-gray-300" />
        }
        header="Feature"
        headerIcon={<FaFeather size={20} />}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
      >
        <FeatureDialogListSection features={features} userId={userId} />
      </GenericDialog>
    </>
  );
}
